<template>
</template>
<script>

export default {
  name: "verifiedEmail",
};
</script>